import { defineMessages, type MessageDescriptor } from 'react-intl';

type MessageKeys = 'loadingApps';

export const messages: Record<MessageKeys, MessageDescriptor> = defineMessages({
	loadingApps: {
		id: 'ai-mate.rovo-settings-modal.side-nav-modal.discovery.loading-apps',
		defaultMessage: 'Loading apps',
		description:
			'Accessible label shown on the spinner while the app discovery section waits for ranking data to load',
	},
});
